export { default } from './Breadcrumbs';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Breadcrumbs/index.js
// module id = 741
// module chunks = 121